module.exports = __webpack_public_path__ + "img/face2.e9e3250c.png";